import { render, staticRenderFns } from "./research.vue?vue&type=template&id=d92ce4f2&"
import script from "./research.vue?vue&type=script&lang=js&"
export * from "./research.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports